/**
 * @prettier
 */

import React, { useCallback } from 'react';
import _values from 'lodash/values';
import _fromPairs from 'lodash/fromPairs';
import { ButtonV2 } from '@zola/zola-ui/src/components/Button';
import { connect } from 'react-redux';
import { getMultiSampleState } from 'cards/selectors/samples';
import { setMultiSampleEnabled as setMultiSampleEnabledAction } from 'cards/actions/samples';
import { openModal, hideModal } from 'cards/actions/modalActions';
import { resetSamplesFlow } from 'cards/reducers/samplesFlow/actions';
import styles from './styles.module.less';

export const CustomizeButtonBase = ({ multiSampleState, showModal, closeModal }) => {
  const handleOpenModal = useCallback((overrideProps = {}) => {
    const cards = _values(multiSampleState.selected);
    const selectedColorSet = _fromPairs(cards.map(card => [card.suiteUUID, card.initialColor]));

    return showModal({
      entryPoint: 'PLP_MULTI',
      cardNameList: cards.map(card => card.name),
      cardSuiteUUIDList: cards.map(card => card.suiteUUID),
      cardUUIDList: cards.map(card => card.uuid),
      closeModal,
      isMagnet: false,
      handleOpenModal,
      selectedColorSet,
      ...overrideProps,
    });
  });

  if (!multiSampleState.enabled) {
    return null;
  }

  const numSelected = Object.keys(multiSampleState.selected).length;

  const buttonDisabled = numSelected === 0;

  let buttonText;

  if (buttonDisabled) {
    buttonText = 'Select Designs To Customize';
  } else {
    buttonText = `Customize ${numSelected} Sample${numSelected === 1 ? '' : 's'}`;
  }

  return (
    <div className={styles.customizationButtonBox}>
      <ButtonV2 disabled={buttonDisabled} onClick={handleOpenModal} fullWidth>
        {buttonText}
      </ButtonV2>
    </div>
  );
};

export const mapStateToProps = state => ({
  multiSampleState: getMultiSampleState(state),
});

const mapDispatchToProps = dispatch => ({
  showModal: (props, overrideOptions = {}) =>
    dispatch(
      openModal('SAMPLES_MODAL', props, {
        bottomModalOnMobile: true,
        closeCallback: () =>
          dispatch(setMultiSampleEnabledAction(null, false))
            .then(() => dispatch(resetSamplesFlow()))
            .then(() => dispatch(hideModal())),
        warnOnClose: true,
        ...overrideOptions,
      })
    ),
  closeModal: (opts = {}) => {
    const { shouldNotDisableMulti } = opts;
    if (shouldNotDisableMulti) {
      return dispatch(hideModal());
    }

    return dispatch(setMultiSampleEnabledAction(null, false)).then(() => dispatch(hideModal()));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomizeButtonBase);
